import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section className="bg-zinc-900 border-y border-zinc-800" data-id="element-126">
      <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-127">
        <div className="flex-shrink-0" data-id="element-128">
          <div className="w-24 h-24 rounded-full bg-yellow-500/10 border-2 border-yellow-500 flex items-center justify-center relative" data-id="element-129">
            <ShieldCheck className="w-12 h-12 text-yellow-500" data-id="element-130" />
          </div>
        </div>
        <div data-id="element-131">
          <h3 className="text-2xl font-bold text-white mb-3" data-id="element-132">
            Garantía de 7 días por inconvenientes
          </h3>
          <p className="text-zinc-400 leading-relaxed" data-id="element-133">
            Si tenés algún inconveniente técnico con la descarga o el acceso al
            material, podés solicitar asistencia dentro de los primeros 7 días.{' '}
            <span className="text-white font-bold" data-id="element-134">
              Compra segura. Acceso inmediato.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}